import { render, staticRenderFns } from "./net_worth.vue?vue&type=template&id=659799c2&"
import script from "./net_worth.vue?vue&type=script&lang=js&"
export * from "./net_worth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports